<template>
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="700" persistent>
        <v-card>
          <v-card-title class="text-h5 orange darken-3 white--text">
            Hay una version para inscripciones UPI
          </v-card-title>
  
          <v-card-text> 
            
            <p class="text-center mt-4 orange--text">
              ¿Deseas probar la version de inscripciones para UPI ahora?
            </p> 
            <p>
              Se abrirá una nueva ventana del navegador. Allí, se realiza la autentificacion automatica con el portal esam. Una vez dentro, se carga el formulario de inscripcion o pre inscripcion. 
            </p> 
            
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="orange" dark @click="enviar()"> probar ahora </v-btn>
            <v-btn color="grey" outlined tile @click="cerrar()"> En otro momento </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script> 
  import {encryptToUpi} from '@/accessToken.js';

  export default {
      data() {
        return {
          loading: true,
          dialog: false,
          programa: {}
        };
      },
      methods: {
        async openmodal(prog) { 
          this.dialog = true; 
          this.programa = prog          
        },
        cerrar() { 
            this.dialog = false;
        }, 
        async enviar(){ 
            const ahref = document.createElement('a')
            const id = this.programa.id
            const tok = encryptToUpi() 
            // ahref.href = `https://upi.edu.pa/portal/upi/portal_login?t=${tok}&return=/marketing/inscribir?prog_id=${id}`
            ahref.href = `https://formulario.upi.edu.pa/portal_login?t=${tok}&return=/marketing/inscribir?prog_id=${id}`
            // ahref.href = `http://localhost:9200/portal/upi/portal_login?t=${tok}&return=/marketing/inscribir?prog_id=${id}`
            ahref.target = '_blank' 
            ahref.click()
        }
      },
    };
  </script>
  